import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  useRequestWithFeedback,
  type OverrideRunProps,
} from "../../../composites";
import { useObjectMemo } from "../../../hooks";

import { API } from "./api";
import { actions as merchantsActions } from "./slice";
import { selectMerchants } from "./selectors";

export const useFetchMerchantsRequest = () => {
  const dispatch = useDispatch();
  const merchants = useSelector(selectMerchants);
  const { send, loading, status } = useRequestWithFeedback<API.Merchant[]>();

  const fetchMerchants = useCallback(
    (overrideRunProps: OverrideRunProps<API.Merchant[]> = {}) => {
      send({
        action: API.fetchMerchants(),
        onData: (data) => {
          dispatch(merchantsActions.setMany(data));
        },
        ...overrideRunProps,
      });
    },
    [dispatch, send],
  );

  return useObjectMemo({
    send: fetchMerchants,
    loading,
    error: status === "error",
    hasData: merchants.length > 0,
  });
};
